import YouTubeEmbed from "@/app/shared/youtube";
import "./index.scss";

export default function Video() {
    return (
        <>
          {/* Video Section */}

      <section className="video-area pb-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="video-inner flex items-stretch">
            <div className="w-1/2">
              <YouTubeEmbed videoId="LqR2FOGMmcA" />
            </div>
            <div className="w-1/2 text-white video-description px-10 py-14">
              <h2 className="text-3xl font-bold text-white uppercase">
                TABLA CATERING NATIONWIDE
              </h2>
              <div className="w-16 h-1 bg-white mr-auto mb-6 mt-2"></div>
              <p className="mb-8 text-[18px] leading-7">
                Tabla Cuisine provides the best Indian catering services in
                Orlando, FL. We help to transform your celebrations into
                unforgettable life experiences.
              </p>
              {/* <a
                href="javascript:;"
                target="_blank"
                className="video-menu_start-button bg-white font-bold rounded py-2 px-3"
              >
                MORE INFO
              </a> */}
            </div>
          </div>
        </div>
      </section>
        </>
    )
}